var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.99925C7.58131 3.99925 3.99925 7.58131 3.99925 12C3.99925 16.4187 7.58131 20.0007 12 20.0007C16.4187 20.0007 20.0007 16.4187 20.0007 12C20.0007 7.58131 16.4187 3.99925 12 3.99925ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "#241E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1497 10.0277C13.0938 9.42127 12.5674 8.96402 11.9553 8.99793C11.9231 8.99971 11.8908 8.99994 11.8585 8.9986C11.2913 8.97506 10.7876 9.35849 10.6593 9.91151C10.5346 10.4493 9.99743 10.7841 9.45964 10.6593C8.92185 10.5346 8.58704 9.99743 8.71182 9.45964C9.05372 7.98604 10.3853 6.95954 11.8931 6.99943C13.5931 6.93108 15.0417 8.23385 15.1478 9.9378C15.1491 9.95848 15.1497 9.9792 15.1497 9.99992C15.1497 11.2764 14.2157 12.0498 13.7057 12.4646C13.6322 12.5243 13.5657 12.5777 13.5051 12.6263C13.3053 12.7867 13.1691 12.8961 13.0582 13.012C13.0282 13.0433 13.0086 13.0667 12.9962 13.0828C12.9542 13.5962 12.5242 13.9997 12 13.9997C11.4479 13.9997 11.0004 13.5521 11.0004 13C11.0004 12.366 11.3468 11.9087 11.6137 11.6298C11.8255 11.4085 12.0985 11.1903 12.3125 11.0193C12.3598 10.9815 12.4042 10.946 12.4444 10.9133C12.9864 10.4727 13.1383 10.2462 13.1497 10.0277Z",
    fill: "#241E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8754 15.8754C10.8754 15.2543 11.3789 14.7508 12.0001 14.7507C12.6211 14.7508 13.1247 15.2538 13.1247 15.8754C13.1247 16.4965 12.6212 17 12.0001 17C11.3789 17 10.8754 16.4965 10.8754 15.8754Z",
    fill: "#241E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOutlined);
export default __webpack_public_path__ + "static/media/question-outlined.acf9ab20ab7c2a085125e1883ee5f7b9.svg";
export { ForwardRef as ReactComponent };